import { useCallback, type KeyboardEvent, type MouseEvent } from "react";
import { useSetRecoilState } from "recoil";

import {
  appLanguageSelector,
  SupportedLanguage,
  validatedLanguage,
} from "@ryde/shared";

import { useLoginTranslation } from "../use-login-translation";

export const useLoginOrSeparator = () => {
  const { i18n, t } = useLoginTranslation();
  const setLanguage = useSetRecoilState(appLanguageSelector);

  const handleOrBadgeActivate = useCallback(
    (
      event: MouseEvent<HTMLSpanElement> | KeyboardEvent<HTMLSpanElement>,
    ): void => {
      if ("key" in event) {
        if (event.key !== "Enter" && event.key !== " ") {
          return;
        }

        event.preventDefault();
      }

      const current: SupportedLanguage =
        validatedLanguage(i18n.language) || "en";
      const next: SupportedLanguage = current === "he" ? "en" : "he";
      // Persist so login preview survives logout and matches post-login sync.
      setLanguage(next);
    },
    [i18n.language, setLanguage],
  );

  const orAriaLabel = t("login.OR_TOGGLE_LANGUAGE_ARIA", {
    defaultValue: "Switch interface language (English / Hebrew)",
  });

  return { handleOrBadgeActivate, orAriaLabel };
};
